import { Entity } from "../../common/entity";
import { z } from "zod";
export const ForgeFeatureRoom = Entity.extend({
    featureId: z.string(),
    projectId: z.string(),
    liveblocksId: z.string(),
});
